import React from 'react';
import AltIso from 'alt/utils/AltIso';

import ShiftDetailsForm from '../forms/ShiftDetailsForm'

import connectToStores from 'alt/utils/connectToStores';

import SeoActions from '../actions/SeoActions';
import ShiftStore from '../stores/ShiftStore';
import ShiftActions from '../actions/ShiftActions';

@AltIso.define((props) => {
    return Promise.all([
        new Promise((resolve) => {
            SeoActions.pushTitle('Create new shift');
            resolve();
        })
    ]);
})
@connectToStores
class CreateShiftStep1 extends React.Component {

    constructor(props) {
        super(props);
    }

    static getPropsFromStores() {
        return {
            shiftStore: ShiftStore.getState()
        };
    }

    static getStores() {
        return [ShiftStore];
    }

    getValue() {
        return this.refs.form.getValue() || {};
    }

    submit(e) {
        e.preventDefault();

        const errors = this.refs.form.validate(true).errors;
        const data = this.refs.form.getValue();
        if (errors) {
            ShiftActions.mergeErrorsIntoState(errors);
        }
        if (data && Object.keys(errors).length === 0) {
            // Cache data and proceed to next step
            ShiftActions.saveStepOneData(data);
            this.props.changeStep.call(this, 2, true);
        }
    }

    getInitialData(data) {
        if (!data.start_date) {
            data.start_date = this.props.createShiftDate;
        }
        return data;
    }

    render () {
        return (
            <div className="create-shift-step-content create-shift-step1">
                <form onSubmit={this.submit.bind(this)} noValidate>
                    <ShiftDetailsForm onChange={this.props.onChange} timezone={this.props.user.timezone} initialFormData={this.getInitialData(this.props.shiftStore.stepOneData)} errors={this.props.shiftStore.createError} ref="form" />

                    <div>
                        <button className="btn btn-small btn-green" type="submit">Continue</button>
                    </div>
                </form>
            </div>
        );
    }
}

export default CreateShiftStep1;



/** WEBPACK FOOTER **
 ** ./app/src/components/CreateShiftStep1.js
 **/